<template>
  <div class="pic-room">

    <div class="chat-con">
      <chat-room v-if="roomId" :thatRoomId="roomId" />
    </div>



  </div>
</template>

<script>
import ChatRoom from './ChatRoom'
import { mapGetters } from 'vuex'
export default {
  components: {
    ChatRoom,
  },
  data(){
    return{
      roomId: '',// 直播间id
    }
  },
  computed:{
    ...mapGetters([
      'liveGoodsDetail',//商品详情
    ]),
  },
  watch: {
    liveGoodsDetail(data){
      console.log(data)
      if(data.purchaseGoods){//是否购买过此商品
        // this.getChatroomInfo()
        this.roomId = data.roomId
      }else { //跳转至商品页面
        this.$dialog.alert({title: '提示', message: '您未购买此商品，是否前往购买？'}).then(() => {
          let query = { goodsId: data.goodsId, shopId: data.shopId, courseType: data.courseType};
          if(this.$route.query.inviteUserId){
            query.inviteUserId = this.$route.query.inviteUserId
          }
          this.$router.push({name: 'goodsDetail', query})
        })
      }
    }
  },
  created(){
    document.title = '图文直播'
    if(this.$route.query.goodsId){ //若为商品，则判断是否有购买过
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('mall/getGoodsDetail', query) // query中必须包含goodsId,shopId,inviteUserId(可选)  //goodsId=1110&shopId=20185
    }else if(this.$route.query.roomId && !this.$route.query.goodsId){
      this.roomId = this.$route.query.roomId
    }
  },
  methods: {

  },


}
</script>

<style lang="less" scoped>
.pic-room{
  position: absolute;z-index: 1;
  width: 100%;height: 100%;
  top: 0;left: 0;bottom: 0;
  /*.live-header{
    position: absolute;z-index: 1;
    width: 375px;height: 260px;
    .img{
      display: block;
      width: 100%;height: 100%;
    }
    .video-con{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;left: 0;
    }
  }*/
  .chat-con{
    position: absolute;z-index: 1;
    width: 375px;bottom: 0;
    top: 0;
    /*top: 260px;*/
  }
}
</style>